import { render, staticRenderFns } from "./PeopleIcon.vue?vue&type=template&id=2ddcd98e&scoped=true"
import script from "./PeopleIcon.vue?vue&type=script&lang=js"
export * from "./PeopleIcon.vue?vue&type=script&lang=js"
import style0 from "./PeopleIcon.vue?vue&type=style&index=0&id=2ddcd98e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddcd98e",
  null
  
)

export default component.exports